import { useMemo } from "react";
import { useGetMarketPenetrationOverTime } from "../../../../../hooks/useGetMarketPenetrationOverTime";
import { getBaseDateChartData } from "./utils";
import { useGetMarketSize } from "../../../../../hooks/useGetMarketSize";
import { QueryVariables } from "../../../../../../../apis/companySearch/marketPenetrationOverTime";
import useMatchProductsById from "../../../../MarketLandscape/hooks/useMatchProductsById";
import { BaseDateChartData } from "../../../../../../../components/charts/BaseDateDataChart/types";
import { useWorkspaceStore } from "../../../../../../../store/workspace/WorkspaceStore";
import { Market } from "../../../../../../../types/workspace";

export const useGetCompetitorTrendData = ({
  companyFilters,
  productIds,
  localizeInstalls = false,
  lookbackYears = 1,
}: QueryVariables) => {
  const { productsNameMapById } = useMatchProductsById(productIds);
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );
  const selectedMarket = useWorkspaceStore((state) => state.selectedMarket);

  const { data: installDetections, loading } = useGetMarketPenetrationOverTime({
    companyFilters,
    productIds,
    localizeInstalls,
    lookbackYears,
    companyMatchFile:
      companyFilters?.opportunityType &&
      workspaceWhitespace?.fileId &&
      workspaceWhitespace?.lastMatched
        ? workspaceWhitespace
        : undefined,
  });

  const { tam, sam, som } = useGetMarketSize();

  const selectedMarketSize = useMemo(
    () => ({ tam, sam, som })[selectedMarket || Market.TAM],
    [sam, selectedMarket, som, tam]
  );

  const data = useMemo<BaseDateChartData[]>(() => {
    return getBaseDateChartData(
      installDetections,
      productsNameMapById,
      selectedMarketSize.companyCount
    );
  }, [installDetections, productsNameMapById, selectedMarketSize.companyCount]);

  return {
    loading,
    data,
  };
};
